import { find, findIndex, map, reduce, sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { Active, Inactive, isActive } from '../../../model/Statuses';
const useQuickAccessActions = ({ groups, input: { onChange, value }, }) => {
    const localGroups = useMemo(() => map(groups, ({ modules, ...rest }) => ({
        ...rest,
        modules: sortBy(modules, ({ id }) => { var _a; return (_a = find(value, { moduleId: id })) === null || _a === void 0 ? void 0 : _a.sequence; }),
    })), [groups, value]);
    const handleDragEnd = useCallback(({ source, destination }) => {
        if (source && destination) {
            const newValue = reduce(localGroups, (acc, { id, modules }) => {
                modules = [...modules];
                if (id === destination.droppableId) {
                    modules.splice(destination.index, 0, modules.splice(source.index, 1)[0]);
                }
                acc.push(...map(modules, ({ id }, sequence) => {
                    var _a;
                    return ({
                        moduleId: id,
                        sequence,
                        status: ((_a = find(value, { moduleId: id })) === null || _a === void 0 ? void 0 : _a.status) || Inactive.value,
                    });
                }));
                return acc;
            }, []);
            onChange(newValue);
        }
    }, [onChange, value, localGroups]);
    const handleClick = useCallback((group, module) => {
        const clickedModule = find(value, { moduleId: module.id });
        if (clickedModule) {
            onChange(map(value, module => module === clickedModule
                ? {
                    ...module,
                    status: isActive(clickedModule)
                        ? Inactive.value
                        : Active.value,
                }
                : module));
        }
        else {
            onChange([
                ...value,
                {
                    sequence: findIndex(group.modules, { id: module.id }),
                    moduleId: module.id,
                    status: Active.value,
                },
            ]);
        }
    }, [onChange, value]);
    return {
        localGroups,
        handleDragEnd,
        handleClick,
    };
};
export default useQuickAccessActions;
